export default __webpack_public_path__ + "static/media/demo_thermal.0fae292b.webp";